// extracted by mini-css-extract-plugin
module.exports = {"container":"frameVisiblePicker_container__wVH9J","button":"frameVisiblePicker_button__Zcjua"};